import z from 'zod';

import {
  AxisValue,
  FillOpacity,
  IsoDateTime,
  SeriesColor,
  StrokeStyle,
} from '#core/components/dashboard/schema.primitives.ts';

export const ReferenceLine = z.object({
  axis: z.enum(['x', 'y']),
  value: AxisValue,
  side: z.enum(['left', 'right']).default('left').describe('Y-axis side; ignored when axis="x".'),
  label: z.string().optional(),
  style: StrokeStyle.default('dashed'),
  color: SeriesColor.default('blue'),
});

export const ReferenceArea = z
  .object({
    axis: z.enum(['x', 'y']),
    start: AxisValue,
    end: AxisValue,
    side: z.enum(['left', 'right']).default('left').describe('Y-axis side; ignored when axis="x".'),
    label: z.string().optional(),
    color: SeriesColor.default('yellow'),
    opacity: FillOpacity.default('light'),
  })
  .describe(
    'Highlights a range on a single axis. Automatically spans the full perpendicular extent. ' +
      'For category x-axis, start/end are category labels.',
  );

export const TimelineReferenceLine = z
  .object({
    value: IsoDateTime,
    label: z.string().optional(),
    style: StrokeStyle.default('dashed'),
    color: SeriesColor.default('blue'),
  })
  .describe('Time markers on the timeline x-axis.');
